import { initClarity, stopClarity } from './clarity';
import { initGa4, stopGa4 } from './ga4';
import type { ConsentChoice } from '../consent/consentStore';

type Deps = {
  initClarity: () => void;
  stopClarity: () => void;
  initGa4: () => void;
  stopGa4: () => void;
};

const defaultDeps: Deps = { initClarity, stopClarity, initGa4, stopGa4 };

// The one place that turns the gated analytics tools on/off for a consent choice.
export function applyAnalyticsConsent(choice: ConsentChoice, deps: Deps = defaultDeps): void {
  if (choice === 'granted') {
    deps.initClarity();
    deps.initGa4();
  } else {
    deps.stopClarity();
    deps.stopGa4();
  }
}
